export const TranslationInPhiladelphia = [
  {
    heading: "Legal Translation",
    detail:
      "Our legal translators have the industry expertise of the law: from corporate law to civic law to criminal law, they can help businesses and individuals communicate in a court of law. Don't trust just any translator aside from legal translators to translate your documents. Choose a legal translator. Choose Tomedes.",
    link: "/legal-translation.php",
  },
  {
    heading: "Medical Translation",
    detail:
      "Do you need a medical translation in Philadelphia? At Tomedes, we provide medical translators and interpreters who have knowledge of distinct medical fields. There are many documents, records, and communications needing to be translated, but at Tomedes, a medical translator or interpreter is just a call away.",
    link: "/medical-translation.php",
  },
  {
    heading: "Technical Translation",
    detail:
      "Tomedes technical translators have the experience and the expertise to translate the most complex technical terminologies--be it in scientific fields or in highly technological industries. Trust Tomedes technical translators with both linguistic versatility and technical solutions.",
    link: "/technical-translation.php",
  },
];

export const LanguagesInPhiladelphia = [
  {
    heading: "Spanish",
    detail:
      "145,000 residents of Philadelphia speak Spanish, a huge number. If you're planning to access the Spanish demographic, or simply want to translate a Spanish document to English or an English document to Spanish, make sure to reach out to Tomedes today.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "Chinese is a very diversified language. Tomedes translation agency can translate from and into both Simplified Chinese and Traditional Chinese, in order to put you in touch with the 31,410 residents in Philadelphia who speak Chinese. Make sure to reach out today.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Vietnamese",
    detail:
      "According to US data, there are 12,974 Vietnamese speakers in Philadelphia. That makes Vietnamese a major language in Philadelphia. If you're thinking about translations for the Philadelphia Vietnamese demographic, why go with other translation agencies aside from Tomedes?",
    link: "/vietnamese-translation.php",
  },
  {
    heading: "Russian",
    detail:
      "26,000 Philadelphia residents speak Russian, which means English to Russian and Russian to English translations will be necessary in Philadelphia. Tomedes translators are highly equipped to provide accurate translations for this and our other languages. Choose Tomedes today.",
    link: "/russian-translation.php",
  },
  {
    heading: "Romanian",
    detail:
      "Romanian is another popular language in Philadelphia, and translations are a highly requested service for this region. Add this to the 500,000 limited English speakers and translations prove important to Philadelphia. Contact Tomedes to learn more.",
    link: "/romanian-translation.php",
  },
  {
    heading: "Arabic",
    detail:
      "In Philadelphia, translations for Arabic prove significant due to the popularity of the Arabic language in this region. If you're looking for growth, it's also an excellent language for international expansion. Want to learn more about international expansion through languages? Contact Tomedes.",
    link: "/arabic-translation.php",
  },
];
